webpackJsonp([6],{

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1600),
  /* template */
  __webpack_require__(1645),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  data: function data() {
    return {
      request: {
        resource: 'auth.logout'
      }
    };
  },
  mounted: function mounted() {
    this.logout();
  },

  watch: {
    logoutStatus: function logoutStatus() {
      if (this.logoutStatus === 200) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_constants__["h" /* LOGOUT */]);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['token']), {
    logoutStatus: function logoutStatus() {
      return this.request.status;
    }
  }),
  methods: {
    logout: function logout() {
      this.request.data = { token: this.token };
      this.request.method = 'post';
      this.$request('save', this.request);
    }
  }
});

/***/ }),

/***/ 1645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card', [(_vm.request.loading) ? _c('v-card-text', [_c('center', [_c('v-progress-circular', {
    staticClass: "mt-5 mb-3",
    attrs: {
      "size": 70,
      "color": "amber",
      "indeterminate": ""
    }
  }), _c('br'), _vm._v("\n        Logging out\n      ")], 1)], 1) : [(_vm.request.status === 200) ? [_c('v-card-title', {
    staticClass: "subheading justify-center"
  }, [_vm._v("\n          Thank you for spending some time with the Guru\n        ")]), _vm._v(" "), _c('v-card-text', [_c('center', [_c('v-icon', {
    staticClass: "mb-3",
    attrs: {
      "size": 70,
      "color": "info"
    }
  }, [_vm._v("power_off")]), _c('br'), _vm._v("\n            You have successfully been logged out."), _c('br')], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.request.status === 399) ? [_c('v-card-text', [_c('center', [_vm._v("\n            Something went wrong. You have only been partially logged out.\n          ")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Retry logout")])], 1)] : _vm._e()]], 2)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.b13e6c2cbe372f802a45.js